import { YELLOW_100, YELLOW_800 } from 'constants/styling/theme'

import Box from '@mui/material/Box'
import { FC, useRef } from 'react'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { useConversationSocket } from 'utils/conversationSocket'
import { useTranslation } from 'react-i18next'

/**
 * Thin banner shown while the conversation WebSocket is disconnected, so the user knows real-time
 * delivery is temporarily paused. Only renders once a connection has been established at least once
 * (avoids flashing during the initial connect) and auto-hides on reconnection.
 */
export const ReconnectionBanner: FC = () => {
  const { t } = useTranslation(['chat'])
  const { isConnected } = useConversationSocket()

  const hasConnectedRef = useRef(false)
  if (isConnected) hasConnectedRef.current = true

  const show = hasConnectedRef.current && !isConnected

  return show
    ? <Box sx={{ backgroundColor: YELLOW_100, padding: '0.4rem 1.2rem' }}>
      <Stack direction="row" alignItems="center" justifyContent="center" gap="0.6rem">
        <Box
          sx={{
            width: '0.7rem',
            height: '0.7rem',
            borderRadius: '50%',
            backgroundColor: YELLOW_800,
            animation: 'pulse 1.2s ease-in-out infinite',
            '@keyframes pulse': { '0%,100%': { opacity: 1 }, '50%': { opacity: 0.3 } },
          }}
        />

        <Typography variant="text-xs" sx={{ color: YELLOW_800, fontWeight: 600 }}>
          {t('chat:thread.reconnecting', { defaultValue: 'Reconnecting…' })}
        </Typography>
      </Stack>
    </Box>
    : null
}
